import React from 'react';
import { TableRow, Tooltip } from '@mui/material';
import { TableCellBody } from '../table/tableCell';

interface TableRowItemProps {
  row: any;
  allocationType: string;
  tab?: string;
}

const TableRowItem: React.FC<TableRowItemProps> = ({ row, allocationType, tab }) => {
  const tableRow = (
    <TableRow
      key={row.email}
      sx={{
        '&:last-child td, &:last-child th': { borderBottom: 0 },
        backgroundColor: (!row.is_test_passed && tab === 'CURRENT') ? 'pink' : 'none',
      }}
    >
      <TableCellBody>{row.email}</TableCellBody>
      <TableCellBody>{row.gigsource_id ? row.gigsource_id : '-'}</TableCellBody>
      <TableCellBody>{row.role ? row.role : '-'}</TableCellBody>
      <TableCellBody>{row.not_started_tasks}</TableCellBody>
      {/* <TableCellBody>{row.active_tasks}</TableCellBody> */}
      <TableCellBody>{row.completed_tasks}</TableCellBody>
      <TableCellBody>{row.pushbacked_tasks}</TableCellBody>
      
      <TableCellBody>{row.in_review_tasks}</TableCellBody>
      <TableCellBody>{row.reviewed_tasks}</TableCellBody>
      <TableCellBody>{row.total_allocated_tasks}</TableCellBody>
      <TableCellBody>{allocationType === 'allocation' ? row.allocation_count : row.unallocation_count}</TableCellBody>
      <TableCellBody>{
        allocationType === 'allocation'
          ? row.total_allocated_tasks_after_this_allocation
          : row.total_allocated_tasks_after_this_unallocation
      }</TableCellBody>
    </TableRow>
  );

  return !row.is_test_passed ? (
    <Tooltip
      title="Red shows expert didn't pass the test. If you still proceed to allocate, they will only be onboarded to the project without task allocation"
      arrow
    >
      {tableRow}
    </Tooltip>
  ) : (
    tableRow
  );
};

export default TableRowItem;
